import { ISimpleListSF } from "./order-list.model";

export interface IOptionalServiceOrder {
  optionalServiceListSF: ISimpleListSF[],
  subtotal: string
}
